import { DollarSign, TrendingUp, Calendar, Gift, Zap } from "lucide-react";
import { GlassCard } from "@/components/GlassCard";
import { fmtUSD } from "@/lib/format";

const KPI = ({ icon: Icon, label, value, sub, testid, accent }) => (
  <GlassCard data-testid={testid}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">{label}</p>
        <p className="font-heading text-2xl sm:text-[26px] font-bold text-white mt-2 tabular-nums leading-none">
          {value}
        </p>
        {sub && <p className="text-xs text-white/55 mt-2">{sub}</p>}
      </div>
      <div className={`w-10 h-10 rounded-2xl glass-pill flex items-center justify-center flex-shrink-0 ${accent}`}>
        <Icon className="w-4.5 h-4.5" strokeWidth={2.2} />
      </div>
    </div>
  </GlassCard>
);

export function KpiCards({ data }) {
  if (!data) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      <KPI
        icon={DollarSign}
        label="Net Income"
        value={fmtUSD(data.net_income)}
        sub={`${data.sales_count} sales · ${data.days_worked} days`}
        accent="text-emerald-300"
        testid="kpi-net-income"
      />
      <KPI
        icon={Zap}
        label="Avg / Day"
        value={fmtUSD(data.avg_per_day)}
        sub={`${data.active_days} active day${data.active_days === 1 ? "" : "s"}`}
        accent="text-amber-300"
        testid="kpi-avg-per-day"
      />
      <KPI
        icon={TrendingUp}
        label="Commission"
        value={fmtUSD(data.commission)}
        sub={`${Math.round(data.commission_rate * 100)}% on ${fmtUSD(data.total_sales_amount)}`}
        accent="text-sky-300"
        testid="kpi-commission"
      />
      <KPI
        icon={Calendar}
        label="Base Pay"
        value={fmtUSD(data.base_pay_total)}
        sub={`$${data.base_pay_per_day}/day · ${data.days_worked} days`}
        accent="text-violet-300"
        testid="kpi-base-pay"
      />
      <KPI
        icon={Gift}
        label="Bonuses"
        value={fmtUSD(data.total_bonuses)}
        sub="Extra rewards this month"
        accent="text-rose-300"
        testid="kpi-bonuses"
      />
    </div>
  );
}
